import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, DataListItem } from '@node-space/ui-components'
import { RequestErrorCallout } from 'components/Errors/RequestErrorCallout'
import { MappedErrorMessageState } from 'types/errors'

interface EarnSheetReviewDataItem {
  id: string
  label: string
  value: string
}

interface EarnSheetReviewProps {
  data: EarnSheetReviewDataItem[]
  requestError: MappedErrorMessageState
  isPending: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const EarnSheetReview = ({
  data,
  requestError,
  isPending,
  onCancel,
  onConfirm,
}: EarnSheetReviewProps) => {
  const { t } = useTranslation()

  return (
    <Box flexCol gapY={16} width="full" paddingY={24}>
      {requestError?.show && <RequestErrorCallout requestError={requestError} />}

      <Box flexCol>
        {data.map(item => (
          <DataListItem
            key={item.id}
            id={item.id}
            testId={`review-${item.id}`}
            title={t(item.label)}
            body={item.value}
          />
        ))}
      </Box>

      <Box flex justify="between" gapX={12} paddingT={24}>
        <Button
          onClick={onCancel}
          variant="secondary"
          type="button"
          testId="cancel-button"
          disabled={isPending}
        >
          {t('cancel')}
        </Button>
        <Button
          variant="primary"
          type="button"
          testId="confirm-button"
          disabled={isPending}
          loading={isPending}
          onClick={onConfirm}
        >
          {t('confirm')}
        </Button>
      </Box>
    </Box>
  )
}
